import { Navigate, useLocation } from 'react-router-dom'
import { useAccountAccess } from '../hooks/useAccountAccess'

type Props = { children: React.ReactNode }

export function RequireFullPanelAccess({ children }: Props) {
  const { placesPreviewOnly, loading } = useAccountAccess()
  const location = useLocation()

  if (loading) return null
  if (placesPreviewOnly) {
    return (
      <Navigate
        to="/panel/miejsca"
        replace
        state={{ trialRedirectFrom: location.pathname }}
      />
    )
  }

  return <>{children}</>
}
